import './index.scss';
import 'components/modals/login_register_modal';
import 'utils/modal_manager';
import 'utils/permissions/permissions';
import 'utils/trackers';
import 'utils/trackers/user';
import { emitBuilderPageVisit } from 'utils/trackers/builder_page_visit';
import {
  initPlansCrazyEgg,
  initPlansEcommerceTracking
} from 'utils/trackers/plans_ecommerce';

const PLAN_CTA_POSITIONS = ['top', 'middle', 'bottom', 'other options'];

window.Odin = window.Odin || {};

window.Odin.trackPlanCtaClick = position => {
  if (!PLAN_CTA_POSITIONS.includes(position)) {
    // eslint-disable-next-line no-console
    console.error(
      `[Odin] trackPlanCtaClick: posição inválida "${position}". Use um de: ${PLAN_CTA_POSITIONS.join(', ')}`
    );
  }

  UserTracker.emit('event', {
    eventName: 'plan cta clicked',
    data: { 'cta position': position }
  });
};

(async () => {
  emitBuilderPageVisit(
    (eventName, params) => {
      UserTracker.emit(eventName, params);
    },
    {
      track: gon.track,
      trackType: gon.track_type
    }
  );

  initPlansEcommerceTracking();
  initPlansCrazyEgg();
})();
